// Security Saga
import { put, call, all, takeLatest } from "redux-saga/effects";
import {
  GET_SECURITY_AUTH_ROLE_LIST,
  GET_SECURITY_AUTH_ROLE_BY_ID,
  CREATE_SECURITY_AUTH_ROLE,
  UPDATE_SECURITY_AUTH_ROLE,
  DELETE_SECURITY_AUTH_ROLE,
  GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST,
  GET_SECURITY_AUTH_ROLE_TO_USER_LIST,
  CREATE_SECURITY_AUTH_ROLE_TO_USER,
  UPDATE_SECURITY_AUTH_ROLE_TO_USER,
  DELETE_SECURITY_AUTH_ROLE_TO_USER,
  CREATE_SECURITY_AUTH_MISSING_REQUEST,
} from "./actionType";

import {
  getSecurityAuthRoleListSuccess,
  getSecurityAuthRoleListFailure,
  getSecurityAuthRoleByIdSuccess,
  getSecurityAuthRoleByIdFailure,
  createSecurityAuthRoleSuccess,
  createSecurityAuthRoleFailure,
  updateSecurityAuthRoleSuccess,
  updateSecurityAuthRoleFailure,
  deleteSecurityAuthRoleSuccess,
  deleteSecurityAuthRoleFailure,
  getMasterSecurityAuthCapabilityListSuccess,
  getMasterSecurityAuthCapabilityListFailure,
  getSecurityAuthRoleToUserListSuccess,
  getSecurityAuthRoleToUserListFailure,
  createSecurityAuthRoleToUserSuccess,
  createSecurityAuthRoleToUserFailure,
  updateSecurityAuthRoleToUserSuccess,
  updateSecurityAuthRoleToUserFailure,
  deleteSecurityAuthRoleToUserSuccess,
  deleteSecurityAuthRoleToUserFailure,
  createSecurityAuthMissingRequestSuccess,
  createSecurityAuthMissingRequestFailure,
} from "./action";

import {
  getSecurityAuthRoleListApi,
  getSecurityAuthRoleByIdApi,
  createSecurityAuthRoleApi,
  updateSecurityAuthRoleApi,
  deleteSecurityAuthRoleApi,
  getMasterSecurityAuthCapabilityListApi,
  getSecurityAuthRoleToUserListApi,
  createSecurityAuthRoleToUserApi,
  updateSecurityAuthRoleToUserApi,
  deleteSecurityAuthRoleToUserApi,
  createSecurityAuthMissingRequestApi,
} from "../../helpers/fakebackend_helper";

// Get security auth role list
function* getSecurityAuthRoleList() {
  try {
    const response = yield call(getSecurityAuthRoleListApi);
    yield put(getSecurityAuthRoleListSuccess(response));
  } catch (error) {
    yield put(getSecurityAuthRoleListFailure(error));
  }
}

export function* watchGetSecurityAuthRoleList() {
  yield takeLatest(GET_SECURITY_AUTH_ROLE_LIST, getSecurityAuthRoleList);
}

// Get security auth role by id
function* getSecurityAuthRoleById(action) {
  try {
    const response = yield call(getSecurityAuthRoleByIdApi, action.payload);
    yield put(getSecurityAuthRoleByIdSuccess(response));
  } catch (error) {
    yield put(getSecurityAuthRoleByIdFailure(error));
  }
}

export function* watchGetSecurityAuthRoleById() {
  yield takeLatest(GET_SECURITY_AUTH_ROLE_BY_ID, getSecurityAuthRoleById);
}

// Create security auth role
function* createSecurityAuthRole(action) {
  try {
    const response = yield call(createSecurityAuthRoleApi, action.payload);
    yield put(createSecurityAuthRoleSuccess(response));
  } catch (error) {
    yield put(createSecurityAuthRoleFailure(error));
  }
}

export function* watchCreateSecurityAuthRole() {
  yield takeLatest(CREATE_SECURITY_AUTH_ROLE, createSecurityAuthRole);
}

// Update security auth role
function* updateSecurityAuthRole(action) {
  try {
    const response = yield call(updateSecurityAuthRoleApi, action.payload);
    yield put(updateSecurityAuthRoleSuccess(response));
  } catch (error) {
    yield put(updateSecurityAuthRoleFailure(error));
  }
}

export function* watchUpdateSecurityAuthRole() {
  yield takeLatest(UPDATE_SECURITY_AUTH_ROLE, updateSecurityAuthRole);
}

// Delete security auth role
function* deleteSecurityAuthRole(action) {
  try {
    const response = yield call(deleteSecurityAuthRoleApi, action.payload);
    yield put(deleteSecurityAuthRoleSuccess(response));
  } catch (error) {
    yield put(deleteSecurityAuthRoleFailure(error));
  }
}

export function* watchDeleteSecurityAuthRole() {
  yield takeLatest(DELETE_SECURITY_AUTH_ROLE, deleteSecurityAuthRole);
}

// Get master security auth capability list
function* getMasterSecurityAuthCapabilityList() {
  try {
    const response = yield call(getMasterSecurityAuthCapabilityListApi);
    yield put(getMasterSecurityAuthCapabilityListSuccess(response));
  } catch (error) {
    yield put(getMasterSecurityAuthCapabilityListFailure(error));
  }
}

export function* watchGetMasterSecurityAuthCapabilityList() {
  yield takeLatest(
    GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST,
    getMasterSecurityAuthCapabilityList
  );
}

// Get security auth role to user list
function* getSecurityAuthRoleToUserList(action) {
  try {
    const response = yield call(
      getSecurityAuthRoleToUserListApi,
      action.payload
    );
    yield put(getSecurityAuthRoleToUserListSuccess(response));
  } catch (error) {
    yield put(getSecurityAuthRoleToUserListFailure(error));
  }
}

export function* watchGetSecurityAuthRoleToUserList() {
  yield takeLatest(
    GET_SECURITY_AUTH_ROLE_TO_USER_LIST,
    getSecurityAuthRoleToUserList
  );
}

// Create security auth role to user
function* createSecurityAuthRoleToUser(action) {
  try {
    const response = yield call(
      createSecurityAuthRoleToUserApi,
      action.payload
    );
    yield put(createSecurityAuthRoleToUserSuccess(response));
  } catch (error) {
    yield put(createSecurityAuthRoleToUserFailure(error));
  }
}

export function* watchCreateSecurityAuthRoleToUser() {
  yield takeLatest(
    CREATE_SECURITY_AUTH_ROLE_TO_USER,
    createSecurityAuthRoleToUser
  );
}

// Update security auth role to user (Task 24736 - StartDate/EndDate only)
function* updateSecurityAuthRoleToUser(action) {
  try {
    const response = yield call(
      updateSecurityAuthRoleToUserApi,
      action.payload
    );
    yield put(updateSecurityAuthRoleToUserSuccess(response));
  } catch (error) {
    yield put(updateSecurityAuthRoleToUserFailure(error));
  }
}

export function* watchUpdateSecurityAuthRoleToUser() {
  yield takeLatest(
    UPDATE_SECURITY_AUTH_ROLE_TO_USER,
    updateSecurityAuthRoleToUser
  );
}

// Delete security auth role to user
function* deleteSecurityAuthRoleToUser(action) {
  try {
    const response = yield call(
      deleteSecurityAuthRoleToUserApi,
      action.payload
    );
    yield put(deleteSecurityAuthRoleToUserSuccess(response));
  } catch (error) {
    yield put(deleteSecurityAuthRoleToUserFailure(error));
  }
}

export function* watchDeleteSecurityAuthRoleToUser() {
  yield takeLatest(
    DELETE_SECURITY_AUTH_ROLE_TO_USER,
    deleteSecurityAuthRoleToUser
  );
}

// Create security auth missing request
function* createSecurityAuthMissingRequest(action) {
  try {
    const response = yield call(
      createSecurityAuthMissingRequestApi,
      action.payload
    );
    yield put(createSecurityAuthMissingRequestSuccess(response));
  } catch (error) {
    yield put(createSecurityAuthMissingRequestFailure(error));
  }
}

export function* watchCreateSecurityAuthMissingRequest() {
  yield takeLatest(
    CREATE_SECURITY_AUTH_MISSING_REQUEST,
    createSecurityAuthMissingRequest
  );
}

export default function* Security() {
  yield all([
    watchGetSecurityAuthRoleList(),
    watchGetSecurityAuthRoleById(),
    watchCreateSecurityAuthRole(),
    watchUpdateSecurityAuthRole(),
    watchDeleteSecurityAuthRole(),
    watchGetMasterSecurityAuthCapabilityList(),
    watchGetSecurityAuthRoleToUserList(),
    watchCreateSecurityAuthRoleToUser(),
    watchUpdateSecurityAuthRoleToUser(),
    watchDeleteSecurityAuthRoleToUser(),
    watchCreateSecurityAuthMissingRequest(),
  ]);
}
